'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = 'react-spectrum-';
var incrementor = 0;

exports.default = function () {
  return PREFIX + ++incrementor;
};